export default "__VITE_ASSET__SdsSObzg__"